import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SelecionarExtratoEstoque } from 'src/app/@shared/models/extrato-estoque.model';
import { ExtratoEstoqueService } from 'src/app/services/clique-retire/extrato-estoque/extrato-estoque.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ModalExtratoEstoqueComponent } from './modal-extrato-estoque/modal-extrato-estoque.component';
import { StorageService } from 'src/app/services/storage/storage.service';
import { FilialService } from 'src/app/services/filial/filial.service';
import { Branch } from 'src/app/@shared/models/filial.model';

@Component({
  selector: 'app-extrato-estoque',
  templateUrl: './extrato-estoque.component.html',
  styleUrls: ['./extrato-estoque.component.scss']
})

export class ExtratoEstoqueComponent implements OnInit {
  usuario = StorageService.getPerfilUsuario();
  public filiais: Branch[];
  isLoading = true;
  paging = { index: 0, size: 10, length: 0 };
  displayedColumns: string[] = ['data', 'totalEntradas', 'totalSaidas', 'totalDevolucao', 'acao'];
  estoqueExtrato: MatTableDataSource<SelecionarExtratoEstoque> = new MatTableDataSource<SelecionarExtratoEstoque>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  filterForm = new FormGroup({
    filial: new FormControl(
      this.usuario.perfilacessotipo === 3 && this.usuario.filialid
        ? { value: this.usuario.filialid, disabled: true }
        : { value: 'Todas', disabled: false }
    ),
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });
  get filial() { return this.filterForm.get('filial').value; }
  get fromDate() { return this.filterForm.get('fromDate').value; }
  get toDate() { return this.filterForm.get('toDate').value; }

  constructor(
    public extratoEstoqueService: ExtratoEstoqueService,
    public filialService: FilialService,
    public dialog: MatDialog,
    public fb: FormBuilder,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 10);
    this.filterForm.get('fromDate').setValue(filtroInicio);
    this.filterForm.get('toDate').setValue(filtroFim);

    this.filialService.getList().subscribe(res => this.filiais = res);
    this.selecionarExtratoEstoque();
  }

  clearFields() {
    if (this.usuario.perfilacessotipo !== 3) {
      this.filterForm.reset();
      this.filterForm.get('filial').setValue('Todas');
    } else {
      this.filterForm.get('fromDate').setValue(null);
      this.filterForm.get('toDate').setValue(null);
    }
    this.selecionarExtratoEstoque();
  }

  selecionarExtratoEstoque() {
    this.isLoading = true;

    const obj = {
      dataInicio: this.fromDate ? this.fromDate.toISOString().split('T')[0] : null,
      dataFim: this.toDate ? this.toDate.toISOString().split('T')[0] : null,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
      filialId: this.filial === 'Todas' ? null : this.filial
    };

    this.extratoEstoqueService.selecionarExtratoEstoque(obj)
      .subscribe(
        (response: HttpResponse<SelecionarExtratoEstoque[]>) => {
          this.estoqueExtrato.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.selecionarExtratoEstoque();
  }

  openDetails(data: Date) {
    const dialogRef = this.dialog.open(ModalExtratoEstoqueComponent, {
      disableClose: true,
      width: '1200px',
      data
    });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response !== 'cancel') { }
      });
  }

  calcularTotais(tipo) {
    return this.estoqueExtrato.data.map(t => t[tipo]).reduce((acc, value) => acc + value, 0);
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
